var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'skinny-button',
    _vm.primary ? 'primary' : '',
    _vm.borderless ? 'borderless' : '',
    _vm.invalid ? 'invalid' : '' ],on:{"click":function($event){!_vm.invalid && _vm.$emit('click', $event)}}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }